module.exports = __webpack_public_path__ + "img/sand-dune-decal-02.88042c26.png";